export default __webpack_public_path__ + "static/media/usd-coin-usdc-logo.c4477cfc.png";